module.exports = __webpack_public_path__ + "img/titxi.d26aa88a.png";